import React, { useState, useEffect } from 'react';
import styles from './Navbar.module.scss'
import cn from 'classnames';
import CurrentTime from '../formElements/ReactTimePicker/currentTime';
import { APP_CONFIG } from '../../../constants/index';
import { connect } from 'react-redux';

const Navbar = (props) => {

    const {
        showMenu, setShowMenu, 
        setCurrentPage, emptyItems, newOrder, processCount, inProgress, yellowCount, orangeCount, redCount, station, setToggle, toggle, isPrioritize,
        setPrioritize, setPriorityItem,states,
        currentState,
        toggleState,
    } = props;

    const navData = [
        { count: newOrder, item: 'New Order' },
        { count: processCount, item: 'Processed' },
        { count: inProgress, item: 'In Progress' }
    ]
    const headerColorCount = [
        {count: yellowCount, bgColor: 'yellow' },
        {count: orangeCount, bgColor: '#F49F40' },
        {count: redCount, bgColor: '#FF6464' }
    ]
    const [responseData, setResponseData] = useState(null);

    const handleClick = () => {
        setToggle(!toggle);
        setCurrentPage(0);
    };
    const handleAbout = (data) => {
        const auth = JSON.parse(window.sessionStorage.getItem('auth'))
        const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'))
        const nativeAppVersion = JSON.parse(window.sessionStorage.getItem('nativeAppVersion'))
        const dataTosend = {
            store: auth.name,
            device: deviceInfo.deviceName,
            appVersion: nativeAppVersion,
            webVersion: APP_CONFIG.VERSION,
            environment: props.environment,
            forSupport: '(888) 265-0707',
            deviceGroup: deviceInfo?.deviceGroup ? deviceInfo?.deviceGroup?.name : ''
        };
        setResponseData({ data, val: dataTosend });
    };

    useEffect(() => handleAbout(), [])


    const handleItemCountNames = (index) => {
        switch (index){
            case 0 : return 'NEW';
            case 1 : return 'SCHED';
            case 2 : return 'PROG';
            default: return '';
        }
    }

    return (
        <div className={cn('w-100 d-flex flex-row fs-12 h-10', styles.navbar)} style={{ backgroundColor: props?.socketConnected ? toggle ? '#bce7f1' : (station === 'prep' || station === 'build') ?states[currentState].color:'#FFFFFF' : '#E13737' }}>

            {/* hamburger div */}
            <div className={cn('d-flex justify-content-center align-items-center', styles.hamburgerDiv)}>
                {!showMenu && (
                    <div role="presentation" className="od-text-primary" onClick={() => setShowMenu(true)}>
                        <i className={cn("fa fa-bars fs-20", styles.hamburgerIcon)} aria-hidden="true" />
                    </div>
                )}
            </div>

            {/* items count div */}
            <div className={cn('d-flex', styles.itemsCountDiv)}>
                {!emptyItems && navData.map((el,index) => (
                    <div key={el.item} className={cn('d-flex justify-content-center align-items-center mr-1')} style={{width: "30%", height: '90%'}}>
                        <div className='w-100 d-flex flex-column justify-content-center align-items-center h-70'>
                            <div className={cn(styles.countCircle, 'd-flex flex-column h-100')} style={{width: '95%'}}>
                                <div>{el.count}</div>
                                <div className='fs-10 text-center'>{handleItemCountNames(index)}</div>
                            </div>
                        </div>
                    </div>
                ))}

                {!emptyItems && headerColorCount?.map((headerCount, index) => {
                    return (
                        <div key={index} className={cn('d-flex justify-content-center align-items-center mr-2', index === 0 && 'ml-2')} style={{ width: "25%", height: '90%' }}>
                            <div className='w-100 d-flex flex-column justify-content-center align-items-center' style={{borderRadius: '50%', overflow: 'hidden', background: headerCount.bgColor }}>
                                <div className={cn('w-100', styles.countCircle)} style={{ background: headerCount.bgColor }}>{headerCount.count} </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            
            {/* filters div */}
            <div className={cn('d-flex justify-content-end align-items-center ml-3', styles.filtersDiv)}>
                {!emptyItems && station === 'expo' && <div className='mr-2'>
                    <button id="prioritize" className={cn('d-flex justify-content-center align-items-center',styles.priorityButton)}
                        style = {{border : !isPrioritize && 'none'}}
                        onClick={() => {
                            setPrioritize(!isPrioritize); 
                            isPrioritize && setPriorityItem({ selectedItemId: null, dropItemId: null });
                        }}
                    >
                        <div>
                         <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 38 35" fill="none">
                           <circle cx="19" cy="19" r="19" fill="#0060FF"/>
                           <path d="M15.7498 10.3558C15.2871 9.88139 14.56 9.88139 14.0973 10.3558C13.6346 10.8302 13.6346 11.5758 14.0973 12.0502L15.4854 13.4735H13.1719C9.20585 13.4735 6 16.7944 6 20.827C6 24.8596 9.20585 28.1806 13.1719 28.1806H17.3031C17.9311 28.1806 18.4599 27.6384 18.4599 26.9945C18.4599 26.3506 17.9311 25.8084 17.3031 25.8084H13.1719C10.4948 25.8084 8.3135 23.5719 8.3135 20.827C8.3135 18.0821 10.4948 15.8456 13.1719 15.8456H15.4854L14.0973 17.2688C13.6346 17.7433 13.6346 18.4888 14.0973 18.9632C14.3286 19.2004 14.6261 19.3021 14.9235 19.3021C15.221 19.3021 15.5184 19.2004 15.7498 18.9632L19.1209 15.5067C19.5836 15.0323 19.5836 14.2867 19.1209 13.8123L15.7498 10.3558Z" fill="white"/>
                           <path d="M23.0434 15.8457H30.9489C31.3389 15.8457 31.6661 15.3035 31.6661 14.6597C31.6661 14.0158 31.3389 13.4736 30.9489 13.4736H23.0434C22.6534 13.4736 22.3262 14.0158 22.3262 14.6597C22.3262 15.3035 22.6534 15.8457 23.0434 15.8457Z" fill="white"/>
                           <path d="M30.9489 25.8086H23.0434C22.6534 25.8086 22.3262 26.3508 22.3262 26.9947C22.3262 27.6385 22.6534 28.1807 23.0434 28.1807H30.9489C31.3389 28.1807 31.6661 27.6385 31.6661 26.9947C31.6661 26.3508 31.3389 25.8086 30.9489 25.8086Z" fill="white"/>
                           <path d="M30.9489 19.6409H23.0434C22.6534 19.6409 22.3262 20.1831 22.3262 20.8269C22.3262 21.4708 22.6534 22.013 23.0434 22.013H30.9489C31.3389 22.013 31.6661 21.4708 31.6661 20.8269C31.6661 20.1831 31.3389 19.6409 30.9489 19.6409Z" fill="white"/>
                         </svg>
                        </div>
                    </button>
                </div>}
                {!emptyItems && (station === 'prep' || station === 'build') && <div>
                    <button className={cn('w-100 d-flex justify-content-center align-items-center border-0', styles.priorityButton)} onClick={() => {toggleState(); setCurrentPage(0)} }>
                        <span style={{ width: '80px' }}>
                            {states[currentState].name}
                        </span>
                    </button>
                </div>}
                {!emptyItems && station === 'expo' && <div>
                    <button className={cn('w-100 d-flex justify-content-center align-items-center border-0', styles.priorityButton)}  onClick={handleClick}>
                        <span style={{ width: '80px' }}>
                           {toggle ? " ALL" : "CURRENT"}
                        </span>
                    </button>
                </div>}
            </div>

            {/* time div */}
            <div className={cn('font-weight-bold d-flex flex-column justify-content-center', styles.timeDiv)}>
                <div className={cn('text-center')}>
                    <CurrentTime className='' seconds={false} />
                </div>
                <div className={cn('text-center')}>
                    {responseData?.val?.device.length < 10 ? responseData?.val?.device : responseData?.val?.device.substring(0, 10) + '...'}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = ({ oauth }) => ({
    socketConnected: oauth.socketConnected,
})

export default connect(mapStateToProps, null)(Navbar)